<template>
  <!-- <b-card class="presales-pipeline" v-if="hasRight(user, 'dashboard', 'view')" no-body>
    <template #header>
      <h6 class="mb-0">PRESALES PIPELINE</h6>
    </template>
    <b-card-body> -->
      <b-row>
        <b-col cols="4" sm="4" md="2">
          <presales-progress-card
            title="Total Leads"
            :value="pipelineData.total_leads.count"
            :subtitle="totalLeadsFollowupSubtitle"
            :progressPercentage="pipelineData.total_leads.progress_percentage"
            color="blue darken-1"
            :info-text="cardLogic.total_leads"
            clickable
            @click.native="$emit('presales-card-click', 'total_leads')"
          />
        </b-col>
        <b-col cols="4" sm="4" md="2">
          <presales-progress-card
            title="Total Calls Done"
            :value="pipelineData.total_calls_done.count"
            :progressPercentage="pipelineData.total_calls_done.progress_percentage"
            color="green darken-1"
            :info-text="cardLogic.total_calls_done"
            clickable
            @click.native="$emit('presales-card-click', 'total_calls_done')"
          />
        </b-col>
        <b-col cols="4" sm="4" md="2">
          <presales-progress-card
            title="Connected Calls"
            :value="pipelineData.connected_calls.count"
            :progressPercentage="pipelineData.connected_calls.conversion_rate"
            subtitle="Conversion Rate"
            color="orange darken-1"
            :info-text="cardLogic.connected_calls"
            clickable
            @click.native="$emit('presales-card-click', 'connected_calls')"
          />
        </b-col>
        <b-col cols="4" sm="4" md="2">
          <presales-progress-card
            title="Interested Leads"
            :value="pipelineData.qualified_interested_leads.count"
            :progressPercentage="pipelineData.qualified_interested_leads.conversion_rate"
            subtitle="Conversion Rate"
            color="purple darken-1"
            :info-text="cardLogic.qualified_interested_leads"
            clickable
            @click.native="$emit('presales-card-click', 'qualified_interested_leads')"
          />
        </b-col>
        <b-col cols="4" sm="4" md="2">
          <presales-progress-card
            title="In Progress Leads"
            :value="pipelineData.in_progress_leads.count"
            :progressPercentage="pipelineData.in_progress_leads.conversion_rate"
            subtitle="Conversion Rate"
            color="blue darken-1"
            :info-text="cardLogic.in_progress_leads"
            clickable
            @click.native="$emit('presales-card-click', 'in_progress_leads')"
          />
        </b-col>
        <b-col cols="4" sm="4" md="2">
          <presales-progress-card
            title="Site Visit Interested"
            :value="pipelineData.site_visit_interested.count"
            :progressPercentage="pipelineData.site_visit_interested.conversion_rate"
            subtitle="Conversion Rate"
            color="green darken-1"
            :info-text="cardLogic.site_visit_interested"
            clickable
            @click.native="$emit('presales-card-click', 'site_visit_interested')"
          />
        </b-col>
      </b-row>
    <!-- </b-card-body>
  </b-card>
</template> -->
</template>

<script>
import PresalesProgressCard from './PresalesProgressCard.vue';
import { BRow, BCol, BCard, BCardBody } from 'bootstrap-vue';
import { canViewCrmDashboardData } from '@/utils/auth';
import { dashboardGet } from './dashboardApi';

const PRESALES_CARD_LOGIC = {
  total_leads: 'Total unique leads created/available in selected filters; subtitle shows follow-up rows logged.',
  total_calls_done: 'Total follow-up calls logged against leads in selected range.',
  connected_calls: 'Calls with connected outcome; conversion rate is connected_calls / total_calls_done.',
  qualified_interested_leads: 'Leads marked interested/qualified after presales calling.',
  in_progress_leads: 'Leads currently in active presales pipeline (not converted/lost).',
  site_visit_interested: 'Interested leads that moved to site-visit-interested stage.',
};

export default {
  name: 'PresalesPipeline',
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    PresalesProgressCard,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
    dashboardData: { type: Object, default: null },
    useAggregate: { type: Boolean, default: false },
    baseApi: {
      type: String,
      default: () => process.env.VUE_APP_APIENDPOINT || '',
    },
    accessToken: {
      type: String,
      default: () => localStorage.getItem('accessToken') || '',
    },
  },
  data() {
    return {
      cardLogic: PRESALES_CARD_LOGIC,
      pipelineData: {
        total_leads: { count: 0, total_followups: 0, progress_percentage: null },
        total_calls_done: { count: 0, progress_percentage: null },
        connected_calls: { count: 0, conversion_rate: null },
        qualified_interested_leads: { count: 0, conversion_rate: null },
        in_progress_leads: { count: 0, conversion_rate: null },
        site_visit_interested: { count: 0, conversion_rate: null },
      },
    };
  },
  computed: {
    totalLeadsFollowupSubtitle() {
      const tl = this.pipelineData.total_leads || {};
      const count = tl.total_followups != null ? tl.total_followups : 0;
      return `Total followup: ${count}`;
    },
    canLoadPipeline() {
      return this.useAggregate || canViewCrmDashboardData(this.user);
    },
  },
  watch: {
    dashboardData: {
      deep: true,
      immediate: true,
      handler() {
        this.syncPipelineFromParent();
      },
    },
    filters: {
      deep: true,
      immediate: true,
      handler() {
        this.syncPipelineFromParent();
      },
    },
    user: {
      deep: true,
      immediate: true,
      handler() {
        if (!this.useAggregate && !this.canLoadPipeline) {
          this.resetPipelineData();
          return;
        }
        this.syncPipelineFromParent();
      },
    },
  },
  mounted() {
    this.syncPipelineFromParent();
  },
  methods: {
    resetPipelineData() {
      this.pipelineData = {
        total_leads: { count: 0, total_followups: 0, progress_percentage: null },
        total_calls_done: { count: 0, progress_percentage: null },
        connected_calls: { count: 0, conversion_rate: null },
        qualified_interested_leads: { count: 0, conversion_rate: null },
        in_progress_leads: { count: 0, conversion_rate: null },
        site_visit_interested: { count: 0, conversion_rate: null },
      };
    },
    normalizeMetricBlock(block, defaults) {
      if (block == null) return { ...defaults };
      if (typeof block === 'number' || typeof block === 'string') {
        return { ...defaults, count: Number(block) || 0 };
      }
      if (typeof block !== 'object') return { ...defaults };
      return { ...defaults, ...block };
    },
    normalizePresalesPipelinePayload(payload) {
      let raw = payload;
      if (raw && raw.data && typeof raw.data === 'object' && raw.total_leads == null) {
        raw = raw.data;
      }
      if (!raw || typeof raw !== 'object') return null;

      return {
        total_leads: this.normalizeMetricBlock(raw.total_leads, {
          count: 0,
          total_followups: 0,
          progress_percentage: null,
        }),
        total_calls_done: this.normalizeMetricBlock(raw.total_calls_done, {
          count: 0,
          progress_percentage: null,
        }),
        connected_calls: this.normalizeMetricBlock(raw.connected_calls, {
          count: 0,
          conversion_rate: null,
        }),
        qualified_interested_leads: this.normalizeMetricBlock(raw.qualified_interested_leads, {
          count: 0,
          conversion_rate: null,
        }),
        in_progress_leads: this.normalizeMetricBlock(raw.in_progress_leads, {
          count: 0,
          conversion_rate: null,
        }),
        site_visit_interested: this.normalizeMetricBlock(raw.site_visit_interested, {
          count: 0,
          conversion_rate: null,
        }),
      };
    },
    applyPresalesPipelineData(payload) {
      const normalized = this.normalizePresalesPipelinePayload(payload);
      if (!normalized) return;
      this.pipelineData = normalized;
    },
    getPresalesPipelineFromParent() {
      if (!this.dashboardData || typeof this.dashboardData !== 'object') return null;
      if (this.dashboardData.presales_pipeline != null) {
        return this.dashboardData.presales_pipeline;
      }
      return null;
    },
    syncPipelineFromParent() {
      if (!this.canLoadPipeline) return;

      const fromParent = this.getPresalesPipelineFromParent();
      if (fromParent != null) {
        this.applyPresalesPipelineData(fromParent);
        return;
      }

      // Aggregate loaded but presales_pipeline missing — fall back to dedicated endpoint
      this.fetchPresalesPipelineData();
    },
    async fetchPresalesPipelineData() {
      if (!this.canLoadPipeline) return;

      const fromParent = this.getPresalesPipelineFromParent();
      if (fromParent != null) {
        this.applyPresalesPipelineData(fromParent);
        return;
      }

      try {
        const response = await dashboardGet(
          this.baseApi,
          this.accessToken,
          '/dashboard/crm/presales-pipeline',
          this.filters
        );
        const body = response.data || {};
        const payload =
          body.data != null && body.data.presales_pipeline != null
            ? body.data.presales_pipeline
            : body.data != null
              ? body.data
              : body;
        if (payload) this.applyPresalesPipelineData(payload);
      } catch (error) {
        console.error('Error fetching presales pipeline data:', error);
      }
    },
  },
};
</script>

<style scoped>
.presales-pipeline {
  margin-top: 20px;
}
</style>
